export default __webpack_public_path__ + "static/media/sad-nodi-reduce-2x.92d97ac9.webp";